import * as paymentActions from 'client/actions/paymentActions'
import * as paymentApi from 'client/api/paymentApi'
import { wrapFontFamily } from 'common/components/entities/Text/utils'
import PropTypes from 'prop-types'
import React, { memo, useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { useTypography } from 'src/editor/shared/hooks/use-typography'
import usePresentPage, { selectors } from '../hooks/usePresentPage'
import { ActivePopup } from './components/popup/active-popup'
import PageUi from './ui/PageUi'

function SalesPage({ children }) {
  const dispatch = useDispatch()
  const isTemplate = usePresentPage(selectors.isTemplate)
  const pageId = usePresentPage(selectors.getPageId)
  const { globalFontFamily, globalFontStyle, globalFontWeight } =
    useTypography()

  useEffect(() => {
    if (!isTemplate && pageId) {
      paymentApi
        .fetchPaymentData(pageId)
        .then(({ data }) => {
          dispatch(paymentActions.fetchPaymentDataSuccess(data))
        })
        .catch(() => {
          // Silently handle all errors - we have stub data
        })
    }
  }, [isTemplate, pageId])
  return (
    <PageUi
      fontFamily={wrapFontFamily(globalFontFamily)}
      fontWeight={globalFontWeight}
      fontStyle={globalFontStyle}
    >
      {children}
      <ActivePopup />
    </PageUi>
  )
}

SalesPage.propTypes = {
  children: PropTypes.node.isRequired,
}

export default memo(SalesPage)
